class ProductCardSlider extends HTMLElement {
  static get observedAttributes () {
    return ['data-initialized']
  }

  constructor () {
    super()
    this.elements = {
      track: this.querySelector('[data-product-card-slider-el="track"]')
    }

    if (!this.elements.track) {
      console.error('One or more required elements are missing')
      return
    }

    this.state = {
      scrollPercentage: 0,
      numberOfSlides: 0
    }
  }

  connectedCallback () {
    if (this.getAttribute('data-initialized') === 'true') {
      this.attachEventListeners()
      this.findNumberOfSlides()
    }
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'data-initialized' && newValue === 'true') {
      this.attachEventListeners()
      this.findNumberOfSlides()
      this.render()
    }
  }

  /**
   * Attaches event listeners to the track and navigation buttons.
   */
  attachEventListeners () {
    this.elements.track.addEventListener('scroll', () => this.calculateScrollPercentage())
  }

  set scrollPercentage (percentage) {
    this.state.scrollPercentage = percentage
    this.setAttribute('data-scroll-percentage', percentage)

    this.render()
  }

  set numberOfSlides (number) {
    this.state.numberOfSlides = number
  }

  findNumberOfSlides () {
    this.numberOfSlides = this.elements.track.children.length
  }

  handleScroll () {
    this.calculateScrollPercentage()
  }

  calculateScrollPercentage () {
    this.scrollPercentage =
      (this.elements.track.scrollLeft /
        (this.elements.track.scrollWidth - this.elements.track.clientWidth)) *
      100
  }
}

customElements.define('product-card-slider', ProductCardSlider)
